import { useRouter } from "next/router";
import RadioGroup, { RadioButton } from "@components/radioGroup";

const types = [
  {
    pathname: "/airdrop",
    label: "All",
  },
  {
    pathname: "/airdrop/active",
    label: "Active",
  },
  {
    pathname: "/airdrop/myAirdrops",
    label: "My Airdrops",
  },
  {
    pathname: "/airdrop/upcoming",
    label: "Upcoming",
  },
  {
    pathname: "/airdrop/finished",
    label: "Finished",
  },
];

export default function Tabs(props) {
  const { asPath } = useRouter();
  const url = new URL(asPath, "http://fake.fake");

  return (
    <RadioGroup aria-label="Airdrop Types" {...props}>
      {types.map(({ pathname, label }) => {
        return (
          <RadioButton
            key={pathname}
            href={pathname}
            enabled={url.pathname === pathname}
            label={label}
          />
        );
      })}
    </RadioGroup>
  );
}
